<template>
<div>
  <div class="success-box">
    <div class="success-box__content">
      <span class="success-box__icon"></span>
      <div class="success-box__text">
        <div class="success-box__tit">恭喜你～注册成功！</div>
        <p v-if="roleId==userRole.IDENTITY3.code||roleId==userRole.IDENTITY4.code">
          完善资料，让百万业主“盯”上你
        </p>
        <p v-if="roleId==userRole.IDENTITY1.code||roleId==userRole.IDENTITY2.code">
          完善资料，赚积分赢好礼
        </p>
      </div>
    </div>
    <div class="success-box__right">
      <img src="https://3vj-fe.3vjia.com/common/images/app-download-qrcode.png" alt="app下载">
      <h5>
        下载并且首登APP <br>
        免费领取88元渲染包
        <small>注：一个手机号只能领取一次</small>
      </h5>
    </div>
  </div>
  <reg-recommend :platformapi="platformapi" :www="www"></reg-recommend>
  <div class="success-bottom">
    <a v-if="roleId==userRole.IDENTITY3.code||roleId==userRole.IDENTITY4.code"
    class="success-box__btn"
    :href="`${www}/ucenter/account`">完善资料</a>
    <a v-if="roleId==userRole.IDENTITY1.code||roleId==userRole.IDENTITY2.code"
    class="success-box__btn"
    :href="`${shopCenter}/setting/shop-base`">完善资料</a>
    <a class="success-bottom__btn--sub" href="javascript:;" @click="clickCallback">到处逛逛</a>
  </div>
</div>
</template>

<script>
import { ENV_API_HOST, USER_ROLE } from '../libs/constants';
import defaults from '../libs/defaults';
import RegRecommend from './RegRecommend.vue';

export default {
  name: 'success-box',
  props: {
    options: { type: Object, default: () => ({}) },
    roleId: { type: String, default: '' },
  },
  data() {
    return {
      userRole: USER_ROLE,
    };
  },
  components: {
    RegRecommend,
  },
  computed: {
    useOptions() {
      return Object.assign({}, defaults, this.options);
    },
    www() {
      return ENV_API_HOST[this.useOptions.env].www;
    },
    shopCenter() {
      return ENV_API_HOST[this.useOptions.env].shopCenter;
    },
    platformapi() {
      return ENV_API_HOST[this.useOptions.env].platformapi;
    },
  },
  methods: {
    clickCallback() {
      this.$emit('clickCallback');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';
.success-box {
  width: 100%;
  text-align: center;
  padding-top: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 50px;
  &__content {
    display: flex;
    align-items: center;
  }
  &__right {
    display: flex;
    align-items: center;
    img {
      width: 110px;
      height: 110px;
    }
    h5 {
      font-size: 16px;
      margin-left: 26px;
      line-height: 1.6;
      color: #333;
    }
    small {
      margin-top: 8px;
      display: block;
      font-size: 12px;
      color: #666666;
      font-weight: normal;
    }
  }
  &__icon {
    width: 100px;
    height: 100px;
    display: inline-block;
    background: url('../imgs/success.png') center no-repeat;
    background-size: 100px;
    margin-right: 20px;
  }
  &__tit {
    font-size: 24px;
    font-weight: 500;
    color:rgba(51,51,51,1);
    line-height: 22px;
    margin: 10px 0;
  }
  &__btn {
    @include loginBtn;
    width: 120px;
    margin: 0 auto;
    display: inline-block;
  }
  &__text {
    text-align: left;
    p {
      font-size: 16px;
      color: #666;
    }
  }
}
.success-bottom {
  text-align: center;
  &__btn--sub {
    color: #999;
    font-size: 16px;
    text-decoration: none;
    margin-left: 20px;
    &:hover {
      color: #147ffa;
    }
  }
}
</style>
